import AppRoutes from "./routes";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import GlobalLoader from "./utils/globalLoader";
import { BrandProvider } from "./hooks/brandProvider";
import { useEffect, useState } from "react";
import { setFavicon } from "./utils/favicon";
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID;
import Lenis from "@studio-freight/lenis";
import { axiosInstance } from "./utils/tokenSetCookie";
import { GoogleOAuthProvider } from "@react-oauth/google";
const theme = createTheme({
  typography: {
    fontFamily: "'Open Sans', sans-serif",
  },
  palette: {
    mode: "light",
  },
});

function App() {


  const [website, setWebsite] = useState(localStorage.getItem("website"));

  useEffect(() => {
    const getWebsiteID = async () => {
      try {
        const url = window.location.hostname;
        console.log("url", url);

        const response = await axiosInstance.post(
          `${API_BASE_URL}websites/get-website-id`,
          { url }
        );

        if (response.status >= 200 && response.status <= 300) {
          console.log("Website ID:", response.data?.data.id);
          localStorage.setItem("website", response.data?.data.id);
          setWebsite(response.data?.data.id);
        }
      } catch (error) {
        console.error("Error fetching website ID:", error);
      }
    };

    if (!website) {
      getWebsiteID();
    }


  }, [website]);

  useEffect(() => {
    setFavicon()
  }, [])

  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.3,   // scroll speed
      easing: (t) => 1 - Math.pow(1 - t, 3), // easing curve
      smoothWheel: true,
      syncTouch: true,
      gestureOrientation: 'vertical',
    });

    // Lenis listens on window (bubble phase) and calls preventDefault(), which
    // blocks native overflow:auto/scroll on child elements. By stopping propagation
    // at document before the event reaches window, Lenis never intercepts wheel
    // events that originate inside a scrollable container.
    const preventLenisOnScrollable = (e: WheelEvent) => {
      let el = e.target as Element | null;
      while (el && el !== document.documentElement) {
        const style = window.getComputedStyle(el);
        if (
          ((style.overflowY === 'auto' || style.overflowY === 'scroll') && el.scrollHeight > el.clientHeight) ||
          ((style.overflowX === 'auto' || style.overflowX === 'scroll') && el.scrollWidth > el.clientWidth)
        ) {
          e.stopPropagation();
          return;
        }
        el = el.parentElement;
      }
    };

    document.addEventListener('wheel', preventLenisOnScrollable, { passive: true });

    function raf(time: number) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    return () => {
      document.removeEventListener('wheel', preventLenisOnScrollable);
      lenis.destroy();
    };
  }, []);


  // Facebook sdk

  // useEffect(() => {
  //   window.fbAsyncInit = function () {
  //     window.FB.init({
  //       appId: import.meta.env.VITE_FACEBOOK_APP_ID, // 👈 your App ID
  //       cookie: true,
  //       xfbml: true,
  //       version: "v19.0", // use latest Graph API version
  //     });
  //   };
  // }, []);



  // useSessionHandler(); // Tracks and removes token on full browser close
  return (
    <ThemeProvider theme={theme}>
      <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
        <BrandProvider>
          <GlobalLoader />
          <CssBaseline />
          <AppRoutes />
        </BrandProvider>
      </GoogleOAuthProvider>
    </ThemeProvider>
  );
}

export default App;
